module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00754.945d0737.jpg";